import "./styles.css";

/**
 * 根据当前路径渲染对应页面。
 * 输入：无，直接读取浏览器 location。
 * 输出：把对应页面挂载到根节点。
 */
async function bootstrap(): Promise<void> {
  const app = document.querySelector<HTMLDivElement>("#app");

  if (!app) {
    throw new Error("缺少 #app 根节点，页面无法启动。");
  }

  const pathname = window.location.pathname;

  if (pathname === "/scan") {
    const { renderScanPage } = await import("./pages/scan");
    await renderScanPage(app);
    return;
  }

  if (pathname === "/view") {
    const { renderViewPage } = await import("./pages/view");
    await renderViewPage(app);
    return;
  }

  const { renderHomePage } = await import("./pages/home");
  await renderHomePage(app);
}

// 启动失败时，把错误直接显示在页面上，避免用户看到白屏。
bootstrap().catch((error: unknown) => {
  const app = document.querySelector<HTMLDivElement>("#app");

  if (!app) {
    return;
  }

  const message = error instanceof Error ? error.message : "页面启动失败。";

  app.innerHTML = `
    <main class="page page--center">
      <section class="panel panel--error">
        <h1>页面启动失败</h1>
        <p>${message}</p>
      </section>
    </main>
  `;
});
